import axios from 'axios'
import { getLocalUser } from './helpers/auth'
import * as M from 'materialize-css'

const user = getLocalUser()

export default {
  state: {
    count: 12,
    currentUser: user,
    isLoggedIn: !!user,
    loading: false,
    auth_error: null,
    customers: [],
    welcome: 'dfd'
  },
  getters: {
    isLoading (state) {
      return state.loading
    },
    isLoggedIn (state) {
      return state.isLoggedIn
    },
    currentUser (state) {
      return state.currentUser
    },
    authError (state) {
      return state.auth_error
    },
    customers (state) {
      return state.customers
    }
  },
  mutations: {
    login (state) {
      state.loading = true
      state.auth_error = null
    },
    loginSuccess (state, payload) {
      state.auth_error = null
      state.isLoggedIn = true
      state.loading = false
      state.currentUser = Object.assign({}, payload.user, {
        token: payload.access_token,
        nomina: payload.nomina
      })
      M.toast({html: '<span>Has <strong>iniciado</strong> sesión con éxito</span>', classes: 'teal lighten-2'})
      localStorage.setItem('user', JSON.stringify(state.currentUser))
    },
    loginFailed (state, payload) {
      state.loading = false
      state.auth_error = payload.error.response.data.error
      M.toast({html: state.auth_error, classes: 'red'})
    },
    logout (state) {
      localStorage.removeItem('user')
      state.isLoggedIn = false
      state.currentUser = null
      M.toast({html: '<span>Has <strong>cerrado</strong> sesión con éxito</span>', classes: 'teal lighten-2'})
    },
    updateCustomers (state, payload) {
      state.customers = payload
    }
  },
  actions: {
    login (context) {
      context.commit('login')
    },
    getCustomers (context) {
      axios.get('/api/customers')
        .then((response) => {
          context.commit('updateCustomers', response.data.customers)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store.js